<template>
  <v-dialog
    :max-width="maxWidth"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Enviar Link de Pago</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-alert
            color="blue"
            dark
            outlined
            v-if="celularPaciente == '' || celularPaciente == null"
            >El paciente no tiene registrado un celular en su ficha, puede
            introducir uno a continuación.</v-alert
          >
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="celular"
                prepend-icon="mdi-whatsapp"
                label="Celular *"
                :rules="celularRules"
                hint="Ingrese el celular con la característica, sin 0, sin 15 y sin guiones. Ej: 1135036549"
                dense
                maxlength="80"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="motivoPago"
                prepend-icon="mdi-whatsapp"
                label="Motivo Pago"
                hint="Ingrese opcionalmente un texto aclarativo del motivo del pago que se enviará junto con el link"
                dense
                maxlength="80"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!valid" @click.stop="enviarMensaje"
            >Enviar Mensaje</v-btn
          >

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="9" md="9">
              <h3>
                El link que se enviará al paciente es:
                <strong>{{ link }}</strong>
              </h3>
            </v-col>
            <v-col cols="12" sm="9" md="9">
              <h3>
                Puede utilizar este link y enviarlo al paciente mediante otra
                vía de comunicación
              </h3>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<style scoped>
.multi-line {
  white-space: pre-line;
}
.v-dialog__content {
  align-items: left;
  justify-content: left;
}
</style>
<script>
import axios from "../../axios-auth.js";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    maxWidth: "100%",
    celular: "",
    celularRules: [(v) => !v || v.length == 10 || "Debe tener 10 caracteres"],
    celularPaciente: "",
    motivoPago: "",
  }),
  props: [
    "visible",
    "link",
    "paciente",
    "pacienteNombre",
    "idProfesional",
    "observaciones",
    "celularProp",
    "nombrePacienteProp",
    "idTurno",
  ],
  computed: {
    show: {
      get() {
        if (this.visible) this.setearModels();
        return this.visible;
      },
      set(value) {
        this.vaciarModels();
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    vaciarModels() {
      this.celular = "";
      this.celularPaciente = "";
      this.motivoPago = "";
    },
    setearModels() {
      this.recuperarCelularPaciente();
      this.motivoPago = this.observaciones ?? "";
    },
    recuperarCelularPaciente() {
      this.celular = this.celularProp;
      this.celularPaciente = this.celularProp;
    },
    enviarMensaje() {
      this.$swal({
        title: "Enviar whats app con link de pago",
        text:
          "¿Desea enviar un mensaje de whats app al paciente con el link de pago?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datos = {
            link: this.link,
            celular: this.celular,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            pacienteNombre: this.nombrePacienteProp || this.pacienteNombre,
            idProfesional: this.idProfesional,
            motivoPago: this.motivoPago,
          };

          let self = this;
          axios
            .get("/Caja/EnviarLinkWA?", {
              params: {
                link: datos.link,
                celular: datos.celular,
                idInstitucion: datos.idInstitucion,
                pacienteNombre: datos.pacienteNombre,
                idProfesional: datos.idProfesional,
                motivoPago: datos.motivoPago,
                idTurno: this.idTurno,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title:
                  "Se envió un mensaje al celular indicado con el link de pago.",
                vm: self,
                timer: 3500,
              });
              this.show = false;
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title:
                  "El link no pudo ser enviado. Intente mas tarde por favor.",
                vm: this,
                timer: 3000,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
  },
};
</script>
